import {
    getCaptchaV3TimeoutReached,
    getCaptchaV3Token,
    getIsCaptchaV3Initialized,
} from '../../../selectors/app';
import { isRecaptchaV3Enabled } from '../../../selectors/splitio';
import { getTicketsCostDetails } from '../../../selectors/tickets/getDisplayCostProps';
import { CheckoutState } from '../../../state';

export const getEnableCapcthaAndRejectUser = (state: CheckoutState) => {
    if (
        getTicketsCostDetails(state).totalCostInCents > 0 ||
        !isRecaptchaV3Enabled(state)
    ) {
        return { rejectUser: false, enableCaptcha: false };
    }

    if (getCaptchaV3Token(state)) {
        return { rejectUser: false, enableCaptcha: true };
    }

    return {
        rejectUser: !(
            getIsCaptchaV3Initialized(state) &&
            getCaptchaV3TimeoutReached(state)
        ),
        enableCaptcha: false,
    };
};
